import { useTranslation } from 'react-i18next';
import { cn, CurrencyUtils } from '@shared/utils';
import { AccountStatus as AccountStatusEnum, type AccountResponse } from '@shared/api';
import { Text } from '@shared/widgets';

interface AccountStatusProps {
  className?: string;
  account: AccountResponse;
}

export const AccountStatus = (props: AccountStatusProps) => {
  const { t } = useTranslation('accounts');

  return (
    <div
      className={cn(
        'flex h-[29px] min-w-[65px] items-center justify-center gap-2 rounded-[45px] px-2 text-white',
        props.account.status === AccountStatusEnum.Active && 'bg-primary',
        ([AccountStatusEnum.Blocked, AccountStatusEnum.Delinquent] as AccountStatusEnum[]).includes(props.account.status) && 'bg-red',
        ([AccountStatusEnum.Closed, AccountStatusEnum.Dormant] as AccountStatusEnum[]).includes(props.account.status) && 'bg-light/70',
        props.className,
      )}
    >
      <Text weight='medium' color='white'>
        {CurrencyUtils.getSymbolByCode(props.account.currency)}
      </Text>
      <Text weight='semibold' size='xxs' color='white'>
        {t(`statuses.account.${props.account.status}`, { ns: 'common' })}
      </Text>
    </div>
  );
};
